import { Adapter } from "./adapter";
import { IAdapter, IAdapterData } from "./adapter.types";

export const mockAdapterData = (): IAdapterData[] => [
  {
    id: 1,
    name: "Sol Customer",
    code: "sol_customer",
    assignable: true,
  },
  {
    id: 2,
    name: "Smartcash Deposit",
    code: "deposit",
    assignable: true,
  },
  {
    id: 3,
    name: "Smartcash Issues",
    code: "issues",
    assignable: true,
  },
  {
    id: 4,
    name: "Smartcash Balances",
    code: "balances",
    assignable: true,
  },
  {
    id: 6,
    name: "Smartcash Accreditations",
    code: "accreditations",
    assignable: true,
  },
];

export const mockAdapter = (data: IAdapterData[] = mockAdapterData()): IAdapter[] =>
  data.map((item) => new Adapter(item));
